import { render, staticRenderFns } from "./statements-layout.vue?vue&type=template&id=4024be86"
import script from "./statements-layout.vue?vue&type=script&lang=js"
export * from "./statements-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports